// Dismiss the mobile on-screen keyboard by blurring the focused input/textarea.
// Call this on step transitions and before opening custom pickers so the keyboard
// doesn't linger and cover UI on mobile.
export function blurActiveInput() {
  if (typeof document === 'undefined') return;
  const el = document.activeElement;
  if (el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.isContentEditable)) {
    el.blur();
  }
}
